import { useContext, useEffect } from "react";
import { RequestHelper } from "../requestHelper";
import { BasicListContext } from "../../contexts/BasicListContext";
import { _ACTIONS, _MEMBER, _TOTALITEMS } from "../constants";
import { createToast } from "../toast";

export const BasicListDataGetter = ({ route, customFilter, customSort }) => {
  const rq = new RequestHelper();
  // Fetch data with filter setted in context;
  const {
    data,
    setData,
    setIsLoading,
    setIsRefetching,
    pagination,
    columnFilters,
    globalFilter,
    sorting,
    setRowCount,
    refresh,
    extraQueryParams,
  } = useContext(BasicListContext);

  const getQuery = () => {
    // Loading
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    // inital query
    let queryData = {};

    // pagination
    queryData = {
      ...queryData,
      page: pagination?.pageIndex + 1,
      itemsPerPage: pagination?.pageSize,
    };

    // Mui Table Filters
    if (columnFilters.length) {
      columnFilters.forEach((filter) => {
        queryData = {
          ...queryData,
          [filter.id]: filter.value,
        };
      });
    }

    // Mui Table Sorting
    if (sorting) {
      sorting.forEach((sort) => {
        const key = "order[" + sort.id + "]";

        queryData = {
          ...queryData,
          [key]: sort.desc ? "desc" : "asc",
        };
      });
    }

    // Custom Filters
    if (customFilter) {
      queryData = customFilter(queryData);
    }

    // Custom Sorting
    if (customSort) {
      queryData = customSort(queryData);
    }

    if (extraQueryParams) {
      for (const key in extraQueryParams) {
        if (extraQueryParams[key] !== null) {
          queryData = {
            ...queryData,
            [key]: extraQueryParams[key],
          };
        }
      }
    }

    return queryData;
  };

  useEffect(() => {
    const queryData = getQuery();

    rq.doRequest(_ACTIONS.GET, route, queryData)
      .then((data) => {
        const response = data.data;

        setData(response[_MEMBER]);
        setRowCount(response[_TOTALITEMS]);
        setIsLoading(false);
      })
      .catch((err) => {
        createToast("error", err.message);
        setIsLoading(false);
      });
  }, [
    refresh,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    extraQueryParams,
  ]);
};

export default BasicListDataGetter;
